import React from 'react';
import { BoxSeam } from 'react-bootstrap-icons';
import './GamePrizes.scss';

// Small shared pieces of the prize wheel's results: a winner's avatar and a
// product thumbnail.

export function Avatar({ winner, size }) {
  const letter = (winner && !winner.anonymous && (winner.name || winner.username || '').trim().charAt(0).toUpperCase()) || '?';
  return (
    <span className="gift-person__avatar" aria-hidden="true" style={size ? { width: size, height: size, fontSize: size * 0.4 } : undefined}>
      <span>{letter}</span>
      {winner?.avatarUrl && (
        <img src={winner.avatarUrl} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
      )}
    </span>
  );
}

export function ProductThumb({ product, size }) {
  return (
    <span className="wheel-thumb" title={product?.name || undefined} aria-hidden="true" style={size ? { width: size, height: size } : undefined}>
      {product?.imageUrl ? <img src={product.imageUrl} alt="" loading="lazy" /> : <BoxSeam size={14} />}
    </span>
  );
}
